import React from "react";
import styled, { createGlobalStyle } from "styled-components";

import uvegLogo from "./LOGO 2.png";
import educaLogo from "./Escudo-IE.png";
import coachBlockchainLogo from "./logo1.png";

const primaryBlue = "#0A5364"; // 🔹 Azul global

const GlobalStyle = createGlobalStyle`
  html, body {
    font-family: 'Merriweather', serif;
    background: #ffffff;
    color: #111111;
    margin: 0;
    padding: 0;
  }
  h1 {
    font-size: 44px;
    font-weight: 800;
    margin: 0 0 20px 0;
    letter-spacing: -0.5px;
  }
  p {
    font-size: 18px;
    line-height: 1.7;
    color: #222;
  }
`;

const Wrapper = styled.div`
  text-align: center;
  padding: 50px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const LogosContainer = styled.div`
  background: #e5e5e5; /* 🔹 Fondo gris claro */
  padding: 15px 25px;
  border-radius: 0; /* Recto */
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;

  img {
    display: block;
  }
`;

const Button = styled.button`
  padding: 15px 30px;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  background-color: ${primaryBlue};
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 20px;

  &:hover {
    background-color: #062925; /* Azul más oscuro */
  }
`;

export default function BotPage() {
  const goToBot = () => {
    window.open(
      "https://chatgpt.com/g/g-67c61a41c8088191abfbbf403ebfe875-coach-blockchain",
      "Chat Inteligente",
      "width=800,height=600,left=200,top=100,noopener,noreferrer"
    );
  };

  return (
    <Wrapper>
      <GlobalStyle />

      {/* Logos */}
      <LogosContainer>
        <img src={uvegLogo} width="140" height="60" alt="UVEG Logo" />
        <img src={coachBlockchainLogo} width="140" height="60" alt="Coach Blockchain Logo" />
      </LogosContainer>

      <h1>Chat Inteligente</h1>
      <p style={{ maxWidth: "600px", textAlign: "left" }}>
        Bienvenido a nuestro <b>Chat Inteligente</b>.  
        Este bot ha sido entrenado para responder todas tus dudas sobre <b>Blockchain</b>,  
        <b>Finanzas Descentralizadas (DeFi)</b>, <b>Smart Contracts</b> y <b>NFTs</b>.  
        Haz tu pregunta y obtén respuestas precisas.
      </p>

      <Button onClick={goToBot}>Abrir Chat Inteligente</Button>
    </Wrapper>
  );
}
